import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    callout: {
      content: `You still have {invitationsLeft} access(es) included in your offer. This doesn’t limit you. 
      Give your team additional accesses for €5/month/person. (excl. tax).
      Accounting accesses remain free and unlimited.`,
      new: 'New',
      title: 'Need more accesses? It’s possible.',
    },
    cancel: 'Cancel',
    invitationsLeft:
      'You have {count} invitation{additionalS} included in your offer ',
    legalBeneficiaries: {
      subtitle:
        'These registered members have already filled in their details, so you can invite them more easily.',
      title: 'Invitations suggestions',
    },
    newInvitation: 'New invitation',
    noMoreInvitationsLeft: 'You don’t have any invites left',
    submit: 'Continue',
    title: 'Invite new members',
  },
  fr: {
    callout: {
      content: `Il vous reste {invitationsLeft} accès inclus dans votre offre. Cela ne vous limite pas.
      Donnez des accès supplémentaires à votre équipe pour 5 € / mois / pers.
      Les accès comptables restent illimités et gratuits.`,
      new: 'Nouveau',
      title: 'Besoin de plus d’accès ? C’est possible.',
    },
    cancel: 'Annuler',
    invitationsLeft:
      'Il vous reste {count} invitation{additionalS} incluse{additionalS} dans votre offre',
    legalBeneficiaries: {
      subtitle:
        'Ces membres inscrits ont déjà rempli leurs informations, vous pouvez les inviter plus rapidement.',
      title: 'Suggestion d’invitations',
    },
    newInvitation: 'Nouvelle invitation',
    noMoreInvitationsLeft: 'Il ne vous reste plus d’invitation',
    submit: 'Continuer',
    title: 'Invitez de nouveaux membres',
  },
} as const);

export default locales;
